<template>
  <div>
    <v-row>
      <v-col :cols="leftColSize">
        <h1 class="headline">
          <slot>{{ text }}</slot>
          <template v-if="resultsCount !== null">
            <span class="font-weight-light">({{ resultsCount }})</span>
          </template>
          <v-spacer />
        </h1>
      </v-col>
      <v-col :cols="rightColSize">
        <v-row
          class="text-right"
          align="center"
          justify="end"
          no-gutters
        >
          <slot name="toolbar.prepend"/>
          <v-btn
            v-if="mode === 'grid' && !!addButtonRoute"
            class="mx-1"
            color="primary"
            icon
            :to="addButtonRoute"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <v-btn
            v-if="mode === 'entity'"
            class="mr-1"
            text
            icon
            @click="$router.back()"
          >
            <v-icon>mdi-window-close</v-icon>
          </v-btn>
          <slot name="toolbar.append"/>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-0">
        <v-progress-linear
          :style="{ 'visibility': !loading ? 'hidden' : 'visible' }"
          :indeterminate="loading"
          color="primary"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'PageHeading',
  props: {
    text: {
      type: String,
      default: null
    },
    leftColSize: {
      type: Number,
      default: 6
    },
    breadcrumbs: {
      type: Array,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: null
    },
    gridDataLoading: {
      type: Boolean,
      default: false
    },
    addButtonRoute: {
      type: Object,
      default: null
    },
    resultsCount: {
      type: Number,
      default: null
    }
  },
  computed: {
    rightColSize () {
      return 12 - this.leftColSize
    }
  }
}
</script>
